import { NgModule } from "@angular/core";

import { FormService } from "@hermes/utils-generic/services/user-interface";

import { DrupalTrayService } from "./drupal-tray.service";
import { DrupalTraySettings } from "./drupal-tray.settings";

@NgModule({ providers: [FormService, DrupalTrayService, DrupalTraySettings] })
export class DrupalTrayServiceModule {}
